export default __webpack_public_path__ + "static/8-bcca2472577b82cb7284450350e4e9db.png";